import React, { memo } from 'react';
import { HeadlineGroup } from '../types';
import MainPanel from '../components/layout/MainPanel';
import StudioSpace from '../components/layout/StudioSpace';

const PanelLayout = memo(({ 
  leftPanelWidth, 
  containerRef, 
  isDragging, 
  handleMouseDown, 
  handleTouchStart, 
  handleDoubleClick, 
  onHeadlineGroupSelect,
  showLoginInHeader,
  initiateGoogleLogin
}: { 
  leftPanelWidth: number; 
  containerRef: React.RefObject<HTMLDivElement>; 
  isDragging: boolean; 
  handleMouseDown: (e: React.MouseEvent) => void; 
  handleTouchStart: (e: React.TouchEvent) => void; 
  handleDoubleClick: () => void; 
  onHeadlineGroupSelect: (group: HeadlineGroup) => void;
  showLoginInHeader?: boolean;
  initiateGoogleLogin?: () => void;
}) => (
  <div ref={containerRef} className="min-h-screen w-full flex relative">
    {/* Left panel with dynamic width */}
    <div className="border-r" style={{ width: `${leftPanelWidth}%` }}>
      <MainPanel 
        onHeadlineGroupSelect={onHeadlineGroupSelect} 
        showLoginInHeader={showLoginInHeader}
        initiateGoogleLogin={initiateGoogleLogin}
      />
    </div>
    
    {/* Draggable divider - hidden on mobile */}
    <div 
      className="absolute top-0 bottom-0 w-1 bg-gray-300 hover:bg-blue-500 cursor-col-resize z-10 flex items-center justify-center hidden md:flex"
      style={{ 
        left: `${leftPanelWidth}%`, 
        transform: 'translateX(-50%)',
        width: isDragging ? '4px' : '2px',
        backgroundColor: isDragging ? 'rgb(59, 130, 246)' : undefined
      }}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      onDoubleClick={handleDoubleClick}
      title="Drag to resize panels. Double-click to reset to 50/50 split."
    >
      {/* Divider handle for better visibility */}
      <div className="h-16 w-4 flex flex-col items-center justify-center rounded-full">
        <div className="h-8 w-1 bg-gray-400 rounded-full"></div>
      </div>
    </div>
    
    {/* Right panel with remaining width - hidden on mobile */}
    <div className="hidden md:block" style={{ width: `${100 - leftPanelWidth}%` }}>
      <StudioSpace />
    </div>
  </div>
));

export default PanelLayout; 